<template>
  <div class="login_con" :style="boxStyle">
    <div class="l_tit">
      企业入驻
    </div>
    <form class="reg_con" data-vv-scope="form2" novalidate>
      <p>
        <select name="member" v-model="form2.businessIdList">
          <option v-for="item in selects" :key="item.businessId" :value="item.businessId">{{item.name}}</option>
        </select>
      </p>
      <p class="zdy_one" v-if="domainType == '0'">
        <input name="domainPrefix1" v-model="form2.code" type="text" class="w295 put_txt" placeholder="企业域名" v-validate="'required'" /> {{domainSuffix}}<!--label id="zdy" @click="domainType='1'">自定义域名</label-->
      </p>
      <!--p class="zdy_two" v-if="domainType == '1'">
        <input name="domainPrefix2" v-model="domainPrefix2" type="text"  class="w295 put_txt input_three" id="ym" placeholder="请输入自定义域名" v-validate="'required'" /><label id="zdy2" @click="domainType='0'">默认域名</label>
      </p--><!--自定义域名显示-->
      <i class="spa7" v-if="errors.first('form2.domainPrefix1')">{{ errors.first('form2.domainPrefix1') }}</i>
      <!--i class="spa7">{{ errors.first('form2.domainPrefix2') }}</i-->
      <ul class="w180 wrap" style="margin-top: 0;">
        <li class="col_1 w70 banben" :class="{foucs:form2.isGroup=='1'}">
          <input name="banben" type="radio" value="1" v-model="form2.isGroup" /> 企业版
        </li>
        <li class="col_2 w70 banben2" :class="{foucs:form2.isGroup=='2'}">
          <input name="banben" type="radio" value="2" v-model="form2.isGroup" /> 集团版
        </li>
      </ul>
      <div class="clear"></div>
      <hr v-if="isNew" style="margin: 0; margin-top: 5px; margin-bottom: 5px;" />
      <div v-if="isNew">
        <p>
          <input v-validate="'required|phone'" name="phone" type="text"  class="w365 put_txt input_three" id="registerThree"  placeholder="手机号" v-model="form2.phone"/>
        </p>
        <i class="spa8">{{ errors.first('form2.phone') }}</i>
        <p>
          <input name="verify" type="text"  class="w235 put_txt input_three" id="registerFour" placeholder="验证码"  v-validate="'required'" v-model="form2.verify"/>
          <get-auth-code @retrieving="getCode" @input-error="popup('请输入正确的手机号')" :phone="form.phone"></get-auth-code>
        </p>
        <i class="spa9">{{ errors.first('form2.verify') }}</i>
        <p><input name="password" type="password"  class="w365 put_txt input_three" id="registerFive" placeholder="密码" v-validate="'required'" v-model="form2.password" /></p>
        <i class="spa10">{{ errors.first('form2.password') }}</i>
      </div>
      <hr class="mt0" style="margin-bottom: 5px;"/>
      <!--p class="mt10 text_sy">试用截止日期：2018/12/11</p-->
      <div class="col_2">
        <input name="isOpen" type="checkbox" value="" v-model="isOpen" /> 企业不公开
        <input name="isAudit" type="checkbox" value="" v-model="isAudit" /> 课程不审核
      </div>
      <div class="clear"></div>
      <p class="xy_text"><input type="checkbox" v-model="agreement" /> 我同意并遵守
        <a>《白玉兰在线服务协议》</a>
        <router-link to="/byl/login" class="ok_reg" v-if="isNew">已注册，去登录 ></router-link>
      </p>
      <p class="wrap w264 mt10">
        <input @click="toLastStep" name="" type="button" class="login_btn" value="上一步" style="width: 128px; margin-right: 2px;" /><!--
        --><input @click="submit('form2')" v-debounce-click name="" type="button" class="login_btn" value="提交注册" style="width: 128px;" />
      </p>
    </form>
  </div>
</template>
<script>

import config from '@/config'
import api from '@/api'
import getAuthCode from '@/components/common/common/getAuthCode.vue'
import '@/utils/validator.js'
export default {
  components: { getAuthCode },
  data () {
    return {
      domainPrefix1: '',
      domainPrefix2: '',
      domainSuffix: '.byl.sh.cn',
      domainType: '0',
      isOpen: false,
      isAudit: false,
      form2: {},
      selectedModules: [],
      selects: [],
      modules: [],
      agreement: false
    }
  },
  mounted () {
    this.getData()
    this.form2 = this.form
    this.form2.isGroup = '2'
    this.form2.businessIdList = ''
  },
  computed: {
    boxStyle () {
      if (!this.isNew) {
        return {
          minHeight: '220px'
        }
      }
    }
  },
  methods: {
    popup (msg) {
      this.$toasted.show(msg)
    },
    getCode () {
      this.$emit('ready-to-get-code', this.form2.phone)
    },
    toLastStep () {
      this.$emit('to-reg-step1')
    },
    getData () {
      this.getBusiness()
    },
    getBusiness () {
      var that = this
      api.post(config.bylApiPath, '/entBusiness/search', null, function (r) { // 正常
        that.selects = r.data
        that.form2.businessIdList = that.selects[0].businessId
      })
    },
    submit (scope) {
      var bus = this
      if (this.agreement) {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            bus.form2.serviceIdList = bus.form.serviceIdList
            bus.form2.isOpen = (bus.isOpen) ? '0' : '1'
            bus.form2.isAudit = (bus.isAudit) ? '0' : '1'
            bus.form2.status = '1' // 1：正常 2：试用 3：禁用
            if (bus.domainType == '0') {
              bus.form2.domain = bus.form2.code + bus.domainSuffix
            } else if (bus.domainType == '1') {
              bus.form2.domain = bus.domainPrefix2
            }
            bus.$emit('ready-to-submit')
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      } else {
        this.$toasted.show('请勾选我同意并遵守 《白玉兰在线服务协议》')
      }
    },
    clickEffects (e) {
      var $elem = $(e.target)
      if ($elem.is('input')) {
        $elem.toggleClass('focus')
      }
    },
    checkedOne (id) {
      let idIndex = this.selectedModules.indexOf(id)
      if (idIndex >= 0) {
        this.selectedModules.splice(idIndex, 1)
      } else {
        this.selectedModules.push(id)
      }
    }
  },
  props: ['form', 'isNew']
}
</script>
<style>
  @import '../common/loginNreg/login.css';
</style>



// WEBPACK FOOTER //
// src/components/common/org-reg/reg2.vue